import React from 'react';
import PropTypes from 'prop-types';
import {api} from '@web/lib/api';
import {notifyAndTrack} from '@web/components/notification';
import {Button} from 'antd';
import {useLocation} from 'wouter';

RunAppButton.propTypes = {
  workflowPath: PropTypes.string.isRequired,
  jobPath: PropTypes.string.isRequired,
  size: PropTypes.string,
  children: PropTypes.node,
};

function RunAppButton(props) {
  const [, setLocation] = useLocation();
  const onRunWorkflow = () => {
    if (props.onClickRun)
      return props.onClickRun(props.workflowPath);

    api.LINE("/workflow/run", {
      workflowPath: props.workflowPath,
      jobPath: props.jobPath,
    })
    .then((response) => {
      if (!response.success)
        return notifyAndTrack.error("Unable to run workflow");

      notifyAndTrack.info("Job is running");
      setLocation("/collections/job-runs");
    })
    .catch((error) => notifyAndTrack.error(error.message));
  }
  return <Button size={props.size || 'large'} className="icon-btn green-color" shape="round" onClick={onRunWorkflow}>
    {props.children || <span>Run Workflow</span>}
  </Button>
}

export default RunAppButton;
